import myAxios from './myAxios';

export {
    getProvider
};

function getProvider(){
    return myAxios.get('/providers/me');
}
